var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.922 19.9219C14.599 20.25 14.0678 20.25 13.7449 19.9219L10.4115 16.5886C10.0834 16.2656 10.0834 15.7344 10.4115 15.4115C10.7345 15.0834 11.2657 15.0834 11.5886 15.4115L14.3334 18.1563L20.4115 12.0781C20.7345 11.75 21.2657 11.75 21.5886 12.0781C21.9167 12.4011 21.9167 12.9323 21.5886 13.2552L14.922 19.9219ZM29.3334 16C29.3334 23.3646 23.3647 29.3334 16.0001 29.3334C8.6355 29.3334 2.66675 23.3646 2.66675 16C2.66675 8.63544 8.6355 2.66669 16.0001 2.66669C23.3647 2.66669 29.3334 8.63544 29.3334 16ZM16.0001 4.33335C9.55737 4.33335 4.33341 9.55731 4.33341 16C4.33341 22.4427 9.55737 27.6667 16.0001 27.6667C22.4428 27.6667 27.6667 22.4427 27.6667 16C27.6667 9.55731 22.4428 4.33335 16.0001 4.33335Z",
    fill: "#7DBE50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheck);
export default __webpack_public_path__ + "static/media/CircleCheck.7cd688f06dcd11ac1c9bbddb78d7adbf.svg";
export { ForwardRef as ReactComponent };